import { Flex, Box, Text } from "rebass/styled-components";
import theme from "../../styles/theme";
import styles from "../../styles/articleStyle";
import Image from "next/image";
import { InferredAuthor, InferredAuthorRole } from "../../types";
import useTranslation from "next-translate/useTranslation";

interface Props {
  authorInfo: InferredAuthor;
}

function Author(props: Props) {
  const { authorInfo: author } = props;
  const { t } = useTranslation("common");

  const roles: InferredAuthorRole[] = author.roles?.nodes || [];

  return (
    <Flex sx={{ flexDirection: "column", gap: "12px" }}>
      <Text as="h3" sx={theme.title}>
        {t("writtenBy")}
      </Text>
      <Flex sx={{ gap: "16px" }}>
        <Box sx={styles.authorPic}>
          <Image
            src={author.avatar?.url || ""}
            alt={author.name || ""}
            loading="lazy"
            width="100%"
            height="100%"
            layout="responsive"
          />
        </Box>
        <Flex sx={{ flexDirection: "column", flex: 1 }}>
          <Flex sx={{ flexDirection: "column", gap: "4px" }}>
            <Text as="h4" sx={theme.label}>
              {author.name}
            </Text>
            <Text as="h4" sx={{ ...theme.label, mb: "12px" }}>
              {roles[0]?.name || ""}
            </Text>
          </Flex>

          <Text as="p" sx={theme.description}>
            {author.description}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default Author;
